import styled from 'styled-components';

export const OrderViewDetailsLeadPlaceholder = styled.div`
  display: flex;
  align-items: center;
`;

export const OrderViewDetailsLeadItemPlaceholder = styled.div`
  flex: 1 0 auto;
`;
